module.exports = __webpack_public_path__ + "static/environments-d46c2869cb9c192d2e2d4951f7d5cc79.png";